import React from 'react';

function DotPulse({ text }) {
  return (
    <div className='animate-bounce'>
      {text}
    </div>
  )
}

export default DotPulse;
